import React from 'react'
import { CardHeader, IconButton, Typography } from '@mui/material'
import { IoChevronBackOutline } from 'react-icons/io5'

export default function HeaderPage({ title, subTitle, action }) {
  return (
    <CardHeader
      sx={stComp.containHeader}
      title={
        title && (
          <Typography textAlign='left' variant='h5' sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
        )
      }
      subheader={
        subTitle && (
          <Typography textAlign='left' variant='subtitle1'>
            {subTitle}
          </Typography>
        )
      }
      avatar={
        action ? (
          <IconButton onClick={() => action()}>
            <IoChevronBackOutline size={30} color={'#ff7043'} />
          </IconButton>
        ) : (
          <></>
        )
      }
    />
  )
}

const stComp = {
  containHeader: {
    height: 'auto',
    width: '100%',
    padding: '0px',
    marginBottom: '15px',
  },
}
